import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Col, Icon, Row } from "../../components/Component";
import Table from "../../components/react-table/Table";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import { Chart } from "chart.js";
import "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import * as moment from "moment";
import { Doughnut } from "react-chartjs-2";
import ReactToPrint from "react-to-print";
import { Button, Card, CardBody } from "reactstrap";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import { GET } from "../../helper/api";
import { getToken } from "../../helper/auth";
import { getColorsArr } from "../../utils/color";

import { useHistory, useLocation } from "react-router-dom";

Chart.register(ChartDataLabels);


const CategoryReport = () => {
  const history = useHistory();

  const printRef = useRef();
  const [smOption, setSmOption] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [chartData, setChartData] = useState(null);
  const [data, setData] = useState(null);
  const [updatedAt, setUpdatedAt] = useState();
  const [rangeDate, setRangeDate] = useState({
    start: searchParams.get("start") ? moment(searchParams.get("start")).startOf("days").toDate() : moment().startOf("months").toDate(),
    end: searchParams.get("end") ? moment(searchParams.get("end")).endOf("days").toDate() : moment().endOf("months").toDate(),
  });

  const colTable = [
    {
      Header: "Tên",
      accessor: "name",
    },
    {
      Header: "Giá trị(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat value={item.amount} displayType={"text"} decimalScale={2} thousandSeparator={","} thousandsGroupStyle="thousand" />,
    },
    {
      Header: "Phần trăm",
      accessor: (item) => `${item.percentAmount}%`,
    },
  ];
  const onRangeChange = (dates) => {
    const [start, end] = dates;
    setRangeDate({
      start: start ? moment(start)?.startOf("days").toDate() : start,
      end: end ? moment(end)?.endOf("days").toDate() : end,
    });
    if (start && end) {
      setUpdatedAt(moment().valueOf());
    }
  };

  useEffect(() => {
    const newParams = new URLSearchParams({
      ...rangeDate,
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });

    GET(
      `/report/report-category-by-timerange`,
      {
        from: moment(rangeDate.start).format("YYYY-MM-DD"),
        to: moment(rangeDate.end).format("YYYY-MM-DD"),
      },
      true
    ).then(({ data: { data } }) => {
      setData(data);
      const inChart = data.IN.filter((e) => e.amount !== 0);
      const outChart = data.OUT.filter((e) => e.amount !== 0);
      const colors = getColorsArr(500);
      const tempChartData = {
        in: {
          labels: inChart.map((c) => c.name),
          datasets: [
            {
              data: inChart.map((c) => c.amount),
              backgroundColor: inChart
                .map((c) => c.color)
                .filter((e) => !!e)
                .concat(...colors),
              hoverOffset: 4,
            },
          ],
        },
        inOption: {
          plugins: {
            datalabels: {
              color: "black",
              textStrokeColor: "white",
              textStrokeWidth: 3,
              formatter: (value, context) => {
                if (!value) {
                  return "";
                }
                return `${inChart[context.dataIndex].percentAmount} %`;
              },
            },
            tooltip: {
              callbacks: {
                label: (context) => `${context.formattedValue} đ`,
              },
            },
          },
        },
        out: {
          labels: outChart.map((c) => c.name),
          datasets: [
            {
              data: outChart.map((c) => c.amount),
              backgroundColor: outChart
                .map((c) => c.color)
                .filter((e) => !!e)
                .concat(...colors),
              hoverOffset: 4,
            },
          ],
        },
        outOption: {
          plugins: {
            datalabels: {
              color: "black",
              textStrokeColor: "white",
              textStrokeWidth: 3,
              formatter: (value, context) => {
                if (!value) {
                  return "";
                }
                return `${outChart[context.dataIndex].percentAmount} %`;
              },
            },
            tooltip: {
              callbacks: {
                label: (context) => `${context.formattedValue} đ`,
              },
            },
          },
        },
      };
      setChartData(tempChartData);
    });
  }, [updatedAt]);

  const exportExcel = () => {
    const params = new URLSearchParams({
      from: moment(rangeDate.start).format("YYYY-MM-DD"),
      to: moment(rangeDate.end).format("YYYY-MM-DD"),
      token: getToken(),
    });
    const url = `${process.env.REACT_APP_API_URL}/api/v1/report/report-category-by-timerange-excel?${params.toString()}`;
    window.open(url, "_blank");
  };

  return !chartData ? null : (
    <React.Fragment>
      <Head title="Báo cáo"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Báo cáo</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div className="toggle-expand-content" style={{ display: smOption ? "block" : "none" }}>
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-group">
                        <div className="form-control-wrap">
                          <DatePicker
                            selected={rangeDate.start}
                            startDate={rangeDate.start}
                            onChange={onRangeChange}
                            endDate={rangeDate.end}
                            maxDate={new Date()}
                            selectsRange
                            className="form-control date-picker"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="d-inline-block mr-3">
                        <ReactToPrint trigger={() => <Button>In</Button>} content={() => printRef.current} pageStyle={``} />
                        <Button onClick={exportExcel} className="ml-3">
                          Xuất excel
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <Card>
            <CardBody>
              <Row>
                <Col sm={12} md={3}>
                  <h3>Thu</h3>

                  <Doughnut data={chartData?.in} options={chartData.inOption} />
                </Col>
                <Col sm={12} md={3}>
                  <h3>Chi</h3>
                  <Doughnut data={chartData?.out} options={chartData.outOption} />
                </Col>
                <Col md={3} size={12}>
                  <h3>Thu</h3>
                  <Table notShowPagi columns={colTable} data={data.IN}></Table>
                </Col>
                <Col md={3} size={12}>
                  <h3>Chi</h3>
                  <Table notShowPagi columns={colTable} data={data.OUT}></Table>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default CategoryReport;
